import React from 'react';
import Waypoint from 'react-waypoint';

import Pet from '../../Global/Pet';
import SnapshotInSection from './SnapshotInSection';

const classnames = require('classnames');

class Section extends React.Component {
	constructor() {
		super();

		this.state = {
			textIsHidden: true,
		};

		this.wayPointEntered = this.wayPointEntered.bind(this);
	}

	getClassNames() {
		const classes = ['contents--left'];

		if (this.state.textIsHidden) {
			classes.push('is-hidden');
		}

		return classnames(classes);
	}

	wayPointEntered() {
		this.setState({ textIsHidden: false });
	}

	render() {
		const Media = this.props.contents.pet ? Pet : SnapshotInSection;

		return (
			<div className={`bg--${this.props.contents.bgColor} section`}>
				<div className="section__contents">
					<div className={this.getClassNames()}>
						<h2>{this.props.contents.title}</h2>
						<p>{this.props.contents.desc}</p>
						<Waypoint onEnter={this.wayPointEntered} />
					</div>
					<div className="contents--right">
						<Media {...this.props.contents.pet} />
					</div>
				</div>
			</div>
		);
	}
}

export default Section;



// WEBPACK FOOTER //
// ./src/components/Site/Home/Section.js